import React from 'react';
import './Footer.css';

const Footer = props => (
    <div className="Footer">
        copyright sam joy productions 2020
        <a href="https://www.instagram.com/spjoy_photo/">Instagram</a>
        <a href="https://twitter.com/spjoy_photo">Twitter</a>
        <div>samjoy.productions@gmail.com</div>
    </div>
);

export default Footer;